﻿function initZerraHeader() {
  const header = document.querySelector('[data-zerra-header]');
  const section = document.querySelector('.shopify-section.zerra-header-section');
  if (!header || !section) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let lastY = window.scrollY;
  let ticking = false;

  const onScroll = () => {
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 40);

    const navOpen = document.body.classList.contains('zerra-nav-open');
    const megaOpen = header.classList.contains('has-mega-open');
    section.classList.toggle('nav-open', navOpen || megaOpen);

    if (!reduceMotion && !navOpen && !megaOpen) {
      const goingDown = y > lastY;
      const pastThreshold = y > 120;
      section.classList.toggle('is-hidden', goingDown && pastThreshold);
    } else {
      section.classList.remove('is-hidden');
    }

    lastY = y;
  };

  requestAnimationFrame(() => {
    section.classList.add('is-ready');
  });

  const onScrollRaf = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      onScroll();
      ticking = false;
    });
  };

  onScroll();
  window.addEventListener('scroll', onScrollRaf, { passive: true });
}

function initZerraDesktopMega() {
  const header = document.querySelector('[data-zerra-header]');
  const section = document.querySelector('.shopify-section.zerra-header-section');
  if (!header) return;
  if (header.dataset.zerraMegaBound === 'true') return;
  header.dataset.zerraMegaBound = 'true';

  const items = [...header.querySelectorAll('[data-zerra-mega-item]')];
  const panels = [...header.querySelectorAll('[data-zerra-mega-panel]')];
  const cartRoot = header.querySelector('[data-zerra-cart]');
  const cartPanel = header.querySelector('[data-zerra-cart-panel]');
  const cartTrigger = header.querySelector('[data-zerra-cart-trigger]');
  const searchRoot = header.querySelector('[data-zerra-search-root]');
  const searchPanel = header.querySelector('[data-zerra-search-panel]');
  const searchTrigger = header.querySelector('[data-zerra-search-trigger]');
  if (!items.length && !cartPanel && !searchPanel) return;

  let closeTimer = null;

  const isDesktop = () => window.matchMedia('(min-width: 1100px)').matches;

  const clearCloseTimer = () => {
    if (!closeTimer) return;
    window.clearTimeout(closeTimer);
    closeTimer = null;
  };

  const restartFades = (panel) => {
    panel.querySelectorAll('.zerra-mega__fade, .zerra-mega__need').forEach((el) => {
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = '';
    });
  };

  const setItemOpen = (item, open) => {
    const trigger = item.querySelector('[data-zerra-mega-trigger]');
    if (!trigger) return;
    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const setPanelActive = (panel, active) => {
    panel.classList.toggle('is-active', active);
    panel.setAttribute('aria-hidden', active ? 'false' : 'true');
  };

  const setCartOpen = (open) => {
    cartRoot?.classList.toggle('is-open', open);
    header.classList.toggle('has-cart-open', open);
    cartTrigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (cartPanel) setPanelActive(cartPanel, open);
  };

  const setSearchOpen = (open) => {
    searchRoot?.classList.toggle('is-open', open);
    header.classList.toggle('has-search-open', open);
    searchTrigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (searchPanel) setPanelActive(searchPanel, open);
  };

  const syncHeaderCtaA11y = (hideCta) => {
    const headerCta = header.querySelector('.js-zerra-header-cta');
    if (!headerCta) return;
    headerCta.setAttribute('aria-hidden', hideCta ? 'true' : 'false');
    if (hideCta) headerCta.setAttribute('tabindex', '-1');
    else headerCta.removeAttribute('tabindex');
  };

  const closeAll = () => {
    clearCloseTimer();
    setProductMega(false);
    items.forEach((item) => setItemOpen(item, false));
    setCartOpen(false);
    setSearchOpen(false);
    if (typeof window.zerraCartSuggestPause === 'function') window.zerraCartSuggestPause();
    header.classList.remove('has-mega-open');
    section?.classList.remove('nav-open');
    syncHeaderCtaA11y(false);
    window.setTimeout(() => {
      if (header.classList.contains('has-mega-open')) return;
      panels.forEach((panel) => setPanelActive(panel, false));
      if (cartPanel) setPanelActive(cartPanel, false);
      if (searchPanel) setPanelActive(searchPanel, false);
    }, 420);
  };

  const openShell = (panel, { hideCta = true } = {}) => {
    const wasOpen = header.classList.contains('has-mega-open');
    header.classList.add('has-mega-open');
    section?.classList.add('nav-open');
    section?.classList.remove('is-hidden');
    syncHeaderCtaA11y(hideCta);
    restartFades(panel);
    if (!wasOpen) void header.offsetHeight;
  };

  const reduceMotionMega = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setProductMega = (on) => {
    const want = Boolean(on) && isDesktop();
    const isOn = header.classList.contains('has-product-mega');
    if (want === isOn) return;

    if (want) {
      const cta = header.querySelector('.zerra-header__cta');
      const cart = header.querySelector('[data-zerra-cart]');
      if (cta && cart) {
        const ctaBox = cta.getBoundingClientRect();
        const cartBox = cart.getBoundingClientRect();
        const gap = Math.max(0, ctaBox.left - cartBox.right);
        const shift = Math.max(0, ctaBox.width + gap);
        header.style.setProperty('--zerra-icon-shift', `${shift}px`);
      } else {
        header.style.setProperty('--zerra-icon-shift', '0px');
      }
    }

    header.classList.toggle('has-product-mega', want);

    if (reduceMotionMega) {
      header.style.setProperty('--zerra-icon-shift', '0px');
    }

    if (!want) {
      window.setTimeout(() => {
        if (header.classList.contains('has-product-mega')) return;
        header.style.removeProperty('--zerra-icon-shift');
      }, 780);
    }
  };

  const openItem = (item) => {
    clearCloseTimer();
    const trigger = item.querySelector('[data-zerra-mega-trigger]');
    const panelId = trigger?.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    items.forEach((other) => setItemOpen(other, other === item));
    panels.forEach((other) => setPanelActive(other, other === panel));
    setCartOpen(false);
    setSearchOpen(false);
    if (typeof window.zerraCartSuggestPause === 'function') window.zerraCartSuggestPause();
    openShell(panel, { hideCta: true });
    setProductMega(true);
  };

  const openCart = () => {
    clearCloseTimer();
    if (!cartPanel) return;
    items.forEach((item) => setItemOpen(item, false));
    panels.forEach((panel) => setPanelActive(panel, false));
    setSearchOpen(false);
    setProductMega(false);
    setCartOpen(true);
    openShell(cartPanel, { hideCta: false });
    if (typeof window.zerraRefreshCart === 'function') window.zerraRefreshCart();
    if (typeof window.zerraCartSuggestPlay === 'function') window.zerraCartSuggestPlay();
  };

  const openSearch = () => {
    clearCloseTimer();
    if (!searchPanel) return;
    items.forEach((item) => setItemOpen(item, false));
    panels.forEach((panel) => setPanelActive(panel, false));
    setCartOpen(false);
    setProductMega(false);
    if (typeof window.zerraCartSuggestPause === 'function') window.zerraCartSuggestPause();
    setSearchOpen(true);
    openShell(searchPanel, { hideCta: false });
    const input = searchPanel.querySelector('[data-zerra-search-input]');
    window.setTimeout(() => input?.focus(), 40);
  };

  window.zerraOpenCart = openCart;

  const scheduleClose = () => {
    clearCloseTimer();
    closeTimer = window.setTimeout(closeAll, 160);
  };

  header.addEventListener('mouseleave', () => {
    if (!isDesktop()) return;
    if (header.classList.contains('has-search-open')) return;
    scheduleClose();
  });

  header.addEventListener('mouseenter', clearCloseTimer);

  items.forEach((item) => {
    const trigger = item.querySelector('[data-zerra-mega-trigger]');

    item.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      if (header.classList.contains('has-search-open')) return;
      openItem(item);
    });

    trigger?.addEventListener('click', (event) => {
      if (!isDesktop()) return;
      event.preventDefault();
      const isOpen = item.classList.contains('is-open') && header.classList.contains('has-mega-open');
      if (isOpen) closeAll();
      else openItem(item);
    });

    trigger?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAll();
        trigger.focus();
      }
    });
  });

  if (cartRoot && cartTrigger && cartPanel) {
    cartRoot.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      if (header.classList.contains('has-search-open')) return;
      openCart();
    });

    cartTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      const isOpen = cartRoot.classList.contains('is-open') && header.classList.contains('has-mega-open');
      if (isOpen) closeAll();
      else openCart();
    });

    cartTrigger.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAll();
        cartTrigger.focus();
      }
    });
  }

  if (searchRoot && searchTrigger && searchPanel) {
    searchTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      const isOpen = searchRoot.classList.contains('is-open') && header.classList.contains('has-mega-open');
      if (isOpen) closeAll();
      else openSearch();
    });

    searchTrigger.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAll();
        searchTrigger.focus();
      }
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && header.classList.contains('has-mega-open')) {
      closeAll();
    }
  });

  document.addEventListener('click', (event) => {
    if (!header.classList.contains('has-mega-open')) return;
    if (header.contains(event.target)) return;
    closeAll();
  });

  window.addEventListener('resize', () => {
    if (isDesktop()) return;
    if (cartRoot?.classList.contains('is-open') || searchRoot?.classList.contains('is-open')) {
      items.forEach((item) => setItemOpen(item, false));
      panels.forEach((panel) => setPanelActive(panel, false));
      return;
    }
    closeAll();
  });
}

function initZerraCartPreview() {
  const header = document.querySelector('[data-zerra-header]');
  const panel = header?.querySelector('[data-zerra-cart-panel]');
  const trigger = header?.querySelector('[data-zerra-cart-trigger]');
  const countEl = header?.querySelector('[data-zerra-cart-count]');
  if (!header || !panel || !trigger) return;
  if (panel.dataset.zerraCartBound === 'true') return;
  panel.dataset.zerraCartBound = 'true';

  const titleEl = panel.querySelector('[data-zerra-cart-title]');
  const copyEl = panel.querySelector('[data-zerra-cart-copy]');
  const itemsEl = panel.querySelector('[data-zerra-cart-items]');
  const totalRow = panel.querySelector('[data-zerra-cart-total-row]');
  const totalEl = panel.querySelector('[data-zerra-cart-total]');
  let fetchToken = 0;
  let changing = false;

  const formatMoney = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
        style: 'currency',
        currency: currency || window.Shopify?.currency?.active || 'EUR',
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return `${((Number(cents) || 0) / 100).toFixed(2)} €`;
    }
  };

  const safeCartUrl = (url) => {
    const raw = String(url || '').trim();
    const fallback = window.routes?.cart_url || '/cart';
    if (!raw) return fallback;
    if (/^(javascript|data|vbscript):/i.test(raw)) return fallback;
    if (/^(https?:|mailto:|tel:)/i.test(raw)) return raw;
    if (raw.startsWith('/') || raw.startsWith('#') || raw.startsWith('./') || raw.startsWith('../')) return raw;
    return fallback;
  };

  const safeCartImg = (url) => {
    const raw = String(url || '').trim();
    if (!raw) return '';
    if (/^(javascript|vbscript):/i.test(raw)) return '';
    if (/^data:/i.test(raw) && !/^data:image\//i.test(raw)) return '';
    if (/^(https?:)/i.test(raw) || raw.startsWith('//') || raw.startsWith('/')) return raw;
    return '';
  };

  const updateCount = (count) => {
    if (!countEl) return;
    if (!count) {
      countEl.textContent = '';
      countEl.hidden = true;
      trigger.setAttribute('aria-label', 'Carrello');
      return;
    }
    countEl.hidden = false;
    countEl.textContent = count > 99 ? '99+' : String(count);
    trigger.setAttribute('aria-label', `Carrello, ${count} articol${count === 1 ? 'o' : 'i'}`);
  };

  const appendControls = (meta, item) => {
    const controls = document.createElement('div');
    controls.className = 'zerra-cart-preview__controls';

    const stepper = document.createElement('div');
    stepper.className = 'zerra-cart-preview__stepper';
    stepper.setAttribute('role', 'group');
    stepper.setAttribute('aria-label', 'Quantità');

    const minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'zerra-cart-preview__step';
    minus.dataset.cartQty = '-1';
    minus.setAttribute('aria-label', 'Diminuisci quantità');
    minus.textContent = '−';

    const value = document.createElement('span');
    value.className = 'zerra-cart-preview__qty-value';
    value.dataset.cartQtyValue = '';
    value.textContent = String(item.quantity || 1);

    const plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'zerra-cart-preview__step';
    plus.dataset.cartQty = '1';
    plus.setAttribute('aria-label', 'Aumenta quantità');
    plus.textContent = '+';

    stepper.appendChild(minus);
    stepper.appendChild(value);
    stepper.appendChild(plus);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'zerra-cart-preview__remove';
    remove.dataset.cartRemove = '';
    remove.setAttribute('aria-label', 'Rimuovi dal carrello');
    const iconTpl = panel.querySelector('[data-zerra-remove-icon]');
    if (iconTpl?.content) {
      remove.appendChild(iconTpl.content.cloneNode(true));
    }

    controls.appendChild(stepper);
    controls.appendChild(remove);
    meta.appendChild(controls);
  };

  const renderItems = (cart) => {
    if (!itemsEl || !titleEl) return;
    const items = Array.isArray(cart.items) ? cart.items : [];
    const count = Number(cart.item_count) || 0;

    updateCount(count);
    panel.classList.toggle('is-empty', count === 0);
    titleEl.textContent = count === 0 ? 'Vuoto per ora' : `${count} articol${count === 1 ? 'o' : 'i'}`;
    if (copyEl) {
      copyEl.textContent =
        count === 0 ? 'Aggiungi un prodotto e lo ritrovi qui.' : 'Rivedi gli articoli prima del checkout.';
    }

    if (totalRow) totalRow.classList.toggle('is-hidden', count === 0);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price, cart.currency);

    itemsEl.replaceChildren();

    if (count === 0) {
      const empty = document.createElement('p');
      empty.className = 'zerra-cart-preview__empty';
      empty.textContent = 'Nessun articolo nel carrello.';
      itemsEl.appendChild(empty);
      return;
    }

    const list = document.createElement('ul');
    list.className = 'zerra-cart-preview__list';
    list.setAttribute('role', 'list');

    items.slice(0, 4).forEach((item) => {
      const li = document.createElement('li');
      li.className = 'zerra-cart-preview__item';
      li.dataset.lineKey = item.key;
      li.dataset.quantity = String(item.quantity || 1);

      const media = document.createElement('a');
      media.className = 'zerra-cart-preview__media';
      media.href = safeCartUrl(item.url);
      if (item.image) {
        const img = document.createElement('img');
        const src = safeCartImg(item.image);
        if (!src) {
          const ph = document.createElement('span');
          ph.className = 'zerra-cart-preview__media-ph';
          ph.setAttribute('aria-hidden', 'true');
          media.appendChild(ph);
        } else {
          img.src = src.includes('?') ? `${src}&width=160` : `${src}?width=160`;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 56;
          img.height = 56;
          media.appendChild(img);
        }
      } else {
        const ph = document.createElement('span');
        ph.className = 'zerra-cart-preview__media-ph';
        ph.setAttribute('aria-hidden', 'true');
        media.appendChild(ph);
      }

      const meta = document.createElement('div');
      meta.className = 'zerra-cart-preview__meta';

      const name = document.createElement('a');
      name.className = 'zerra-cart-preview__name';
      name.href = safeCartUrl(item.url);
      name.textContent = item.product_title || item.title || 'Prodotto';
      meta.appendChild(name);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('p');
        variant.className = 'zerra-cart-preview__variant';
        variant.textContent = item.variant_title;
        meta.appendChild(variant);
      }

      appendControls(meta, item);

      const price = document.createElement('p');
      price.className = 'zerra-cart-preview__price';
      price.textContent = formatMoney(item.final_line_price ?? item.line_price, cart.currency);

      li.appendChild(media);
      li.appendChild(meta);
      li.appendChild(price);
      list.appendChild(li);
    });

    itemsEl.appendChild(list);

    if (count > 4) {
      const more = document.createElement('p');
      more.className = 'zerra-cart-preview__more';
      more.textContent = `+${count - 4} altri nel carrello`;
      itemsEl.appendChild(more);
    }
  };

  const refreshCart = () => {
    const token = ++fetchToken;
    const url = `${window.routes?.cart_url || '/cart'}.js`;
    fetch(url, { credentials: 'same-origin' })
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((cart) => {
        if (token !== fetchToken) return;
        renderItems(cart || {});
      })
      .catch(() => {});
  };

  const changeLine = (key, quantity) => {
    if (!key || changing) return;
    changing = true;
    const url = window.routes?.cart_change_url || '/cart/change.js';
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((cart) => {
        renderItems(cart || {});
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zerra-header-cart', cartData: cart });
        }
      })
      .catch(() => refreshCart())
      .finally(() => {
        changing = false;
      });
  };

  itemsEl?.addEventListener('click', (event) => {
    const row = event.target.closest('[data-line-key]');
    if (!row) return;
    const key = row.dataset.lineKey;
    const current = parseInt(row.dataset.quantity || '1', 10) || 1;

    if (event.target.closest('[data-cart-remove]')) {
      event.preventDefault();
      changeLine(key, 0);
      return;
    }

    const stepBtn = event.target.closest('[data-cart-qty]');
    if (!stepBtn) return;
    event.preventDefault();
    const delta = parseInt(stepBtn.dataset.cartQty, 10) || 0;
    changeLine(key, Math.max(0, current + delta));
  });

  window.zerraRefreshCart = refreshCart;

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === 'zerra-header-cart') return;
      refreshCart();
    });
  }

  document.addEventListener('cart:updated', refreshCart);
}

function initZerraMobileNav() {
  const toggle = document.querySelector('[data-zerra-nav-toggle]');
  const overlay = document.querySelector('[data-zerra-nav]');
  const closeBtn = document.querySelector('[data-zerra-nav-close]');
  const section = document.querySelector('.shopify-section.zerra-header-section');
  if (!toggle || !overlay) return;

  if (overlay.dataset.zerraNavBound === 'true') return;
  overlay.dataset.zerraNavBound = 'true';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let closing = false;
  let closeTimer = null;
  let lastFocus = null;
  let closeDone = false;

  const setOriginFromToggle = () => {
    const rect = toggle.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;
    overlay.style.setProperty('--nav-ox', `${Math.round(x)}px`);
    overlay.style.setProperty('--nav-oy', `${Math.round(y)}px`);
  };

  const finishClose = () => {
    if (closeDone) return;
    closeDone = true;
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    closing = false;
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    } else {
      toggle.focus({ preventScroll: true });
    }
  };

  const setOpen = (open) => {
    if (open) {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      closing = false;
      closeDone = false;
      lastFocus = document.activeElement;
      setOriginFromToggle();
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      overlay.classList.remove('is-open');
      void overlay.offsetWidth;
      overlay.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Chiudi menu');
      document.body.classList.add('zerra-nav-open');
      section?.classList.add('nav-open');
      section?.classList.remove('is-hidden');
      window.setTimeout(() => closeBtn?.focus({ preventScroll: true }), reduceMotion ? 0 : 280);
      return;
    }

    if (!overlay.classList.contains('is-open') || closing) return;
    closing = true;
    setOriginFromToggle();
    overlay.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Apri menu');
    document.body.classList.remove('zerra-nav-open');
    section?.classList.remove('nav-open');

    if (reduceMotion) {
      finishClose();
      return;
    }

    const onEnd = (event) => {
      if (event.target !== overlay) return;
      if (event.propertyName && event.propertyName !== 'clip-path') return;
      overlay.removeEventListener('transitionend', onEnd);
      finishClose();
    };
    overlay.addEventListener('transitionend', onEnd);
    closeTimer = window.setTimeout(() => {
      overlay.removeEventListener('transitionend', onEnd);
      finishClose();
    }, 480);
  };

  toggle.addEventListener('click', () => {
    setOpen(!overlay.classList.contains('is-open'));
  });

  closeBtn?.addEventListener('click', () => setOpen(false));

  overlay.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || !overlay.contains(link)) return;
    setOpen(false);
  });

  overlay.querySelectorAll('[data-zerra-nav-details]').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      const item = details.parentElement;
      const list = item?.parentElement;
      if (!list) return;
      [...list.children].forEach((siblingItem) => {
        const other = siblingItem.querySelector(':scope > details[data-zerra-nav-details]');
        if (other && other !== details) other.open = false;
      });
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
      event.preventDefault();
      setOpen(false);
    }
  });

  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 1100px)').matches) setOpen(false);
  });
}
function initZerraCartSuggest() {
  const root = document.querySelector('[data-zerra-cart-suggest]');
  if (!root) return;
  if (root.dataset.zerraSuggestBound === 'true') return;
  root.dataset.zerraSuggestBound = 'true';

  const track = root.querySelector('[data-zerra-suggest-track]');
  const viewport = root.querySelector('[data-zerra-suggest-viewport]');
  const cards = [...root.querySelectorAll('[data-zerra-suggest-card]')];
  const prevBtn = root.querySelector('[data-zerra-suggest-prev]');
  const nextBtn = root.querySelector('[data-zerra-suggest-next]');
  if (!track || !viewport || !cards.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let index = 0;
  let timer = null;
  let hoverPaused = false;
  let playTimer = 0;

  const isCartOpen = () =>
    Boolean(document.querySelector('[data-zerra-header]')?.classList.contains('has-cart-open'));

  const gapPx = () => {
    const style = window.getComputedStyle(track);
    return parseFloat(style.columnGap || style.gap) || 0;
  };

  const stepPx = () => {
    const card = cards[0];
    if (!card) return 0;
    const w = card.offsetWidth || card.getBoundingClientRect().width || 0;
    return w > 0 ? w + gapPx() : 0;
  };

  const maxIndex = () => {
    if (cards.length <= 1) return 0;
    const step = stepPx();
    const viewW = viewport.clientWidth || viewport.offsetWidth || 0;
    if (step <= 0 || viewW <= 0) return cards.length - 1;
    const visible = Math.max(1, Math.floor((viewW + 4) / step));
    const byOverflow = Math.max(0, cards.length - visible);
    /* Se tutto entra in viewport, avanza comunque di 1 card (frecce + autoplay) */
    return byOverflow > 0 ? byOverflow : cards.length - 1;
  };

  const render = () => {
    const max = Math.max(maxIndex(), 0);
    if (index > max) index = max > 0 ? index % (max + 1) : 0;
    if (index < 0) index = max;
    const step = stepPx();
    const x = step > 0 ? index * step : 0;
    track.style.transform = `translate3d(${-x}px, 0, 0)`;
  };

  const go = (delta) => {
    if (cards.length <= 1) return;
    const max = maxIndex();
    const pages = Math.max(1, max + 1);
    index = (index + delta + pages * 10) % pages;
    render();
  };

  const stopAutoplay = () => {
    if (!timer) return;
    window.clearInterval(timer);
    timer = null;
  };

  const startAutoplay = () => {
    stopAutoplay();
    if (reduceMotion || hoverPaused || !isCartOpen()) return;
    if (cards.length < 2) return;
    timer = window.setInterval(() => go(1), 2000);
  };

  const onNav = (delta) => (event) => {
    event.preventDefault();
    event.stopPropagation();
    go(delta);
  };

  prevBtn?.addEventListener('click', onNav(-1));
  nextBtn?.addEventListener('click', onNav(1));
  if (prevBtn) {
    prevBtn.disabled = false;
    prevBtn.removeAttribute('disabled');
  }
  if (nextBtn) {
    nextBtn.disabled = false;
    nextBtn.removeAttribute('disabled');
  }

  /* Pausa autoplay solo sulla strip prodotti, non sulle frecce */
  viewport.addEventListener('mouseenter', () => {
    hoverPaused = true;
    stopAutoplay();
  });
  viewport.addEventListener('mouseleave', () => {
    hoverPaused = false;
    startAutoplay();
  });

  let resizeTimer = 0;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      render();
      if (isCartOpen()) startAutoplay();
    }, 120);
  });

  window.zerraCartSuggestPlay = () => {
    window.clearTimeout(playTimer);
    hoverPaused = false;
    const kick = () => {
      render();
      startAutoplay();
    };
    requestAnimationFrame(() => requestAnimationFrame(kick));
    playTimer = window.setTimeout(kick, 480);
  };

  window.zerraCartSuggestPause = () => {
    window.clearTimeout(playTimer);
    stopAutoplay();
  };

  render();
}

function initZerraLangSelectors() {
  const hreflangUrl = (prefix) => {
    const links = [...document.querySelectorAll('link[hreflang]')];
    const exact = links.find((l) => (l.getAttribute('hreflang') || '').toLowerCase() === prefix);
    if (exact?.href) return exact.href;
    const starts = links.find((l) => (l.getAttribute('hreflang') || '').toLowerCase().startsWith(`${prefix}-`));
    return starts?.href || '';
  };

  const pathWithoutLocale = () => {
    const path = window.location.pathname || '/';
    return path.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i, '') || '/';
  };

  const buildLangUrl = (code) => {
    const wantEn = String(code || '').toLowerCase().startsWith('en');
    const alt = hreflangUrl(wantEn ? 'en' : 'it') || hreflangUrl(wantEn ? 'en' : 'x-default');
    if (!alt) return '';

    try {
      const target = new URL(alt, window.location.origin);
      const bare = pathWithoutLocale();
      // Root EN tipo https://zerrahub.com/en → mantieni path corrente
      if (/\/en\/?$/i.test(target.pathname)) {
        target.pathname = bare === '/' ? '/en' : `/en${bare}`;
      } else if (!wantEn) {
        target.pathname = bare;
      }
      target.search = window.location.search || '';
      target.hash = '';
      return target.toString();
    } catch (e) {
      return alt;
    }
  };

  document.querySelectorAll('[data-zerra-lang]').forEach((root) => {
    if (root.dataset.zerraLangBound === 'true') return;
    root.dataset.zerraLangBound = 'true';

    const toggle = root.querySelector('[data-zerra-lang-toggle]');
    const panel = root.querySelector('[data-zerra-lang-panel]');
    const input = root.querySelector('[data-zerra-lang-input]');
    const form = root.querySelector('form');
    if (!toggle || !panel || !form) return;

    const setOpen = (open) => {
      root.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    };

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setOpen(!root.classList.contains('is-open'));
    });

    root.querySelectorAll('[data-zerra-lang-option]').forEach((option) => {
      option.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const value = option.getAttribute('data-value');
        if (!value) return;

        const current = (document.documentElement.lang || '').toLowerCase();
        const goingEn = value.toLowerCase().startsWith('en');
        const alreadyEn = current.startsWith('en');
        if ((goingEn && alreadyEn) || (!goingEn && !alreadyEn && (current === 'it' || current.startsWith('it')))) {
          setOpen(false);
          return;
        }

        /* Markets: EN è su zerrahub.com, non su zerra.it — naviga via hreflang */
        const dest = buildLangUrl(value);
        if (dest) {
          window.location.assign(dest);
          return;
        }

        if (input) input.value = value;
        setOpen(false);
        form.submit();
      });
    });

    document.addEventListener('click', (event) => {
      if (!root.classList.contains('is-open')) return;
      if (root.contains(event.target)) return;
      setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initZerraHeader();
  initZerraCartPreview();
  initZerraCartSuggest();
  initZerraLangSelectors();
  initZerraDesktopMega();
  initZerraMobileNav();
});

document.addEventListener('shopify:section:load', () => {
  const overlay = document.querySelector('[data-zerra-nav]');
  const header = document.querySelector('[data-zerra-header]');
  const panel = document.querySelector('[data-zerra-cart-panel]');
  const suggest = document.querySelector('[data-zerra-cart-suggest]');
  if (overlay) delete overlay.dataset.zerraNavBound;
  if (header) delete header.dataset.zerraMegaBound;
  if (panel) delete panel.dataset.zerraCartBound;
  if (suggest) delete suggest.dataset.zerraSuggestBound;
  document.querySelectorAll('[data-zerra-lang]').forEach((el) => delete el.dataset.zerraLangBound);
  initZerraHeader();
  initZerraCartPreview();
  initZerraCartSuggest();
  initZerraLangSelectors();
  initZerraDesktopMega();
  initZerraMobileNav();
});
